export default __webpack_public_path__ + "static/media/lancer.7cffb6c5.gif";